import { z } from 'zod/v4';

/**
 * Schema for validating impersonate user requests.
 * This is used for admin login functionality where an admin user
 * can impersonate another user for dashboard access.
 * Matches the structure of AdminImpersonationCredential.
 */
export const ImpersonateUserRequestSchema = z
    .object({
        userSessionId: z
            .number()
            .int()
            .positive('User Session ID must be a positive integer')
            .max(Number.MAX_SAFE_INTEGER, 'User Session ID too large'),
        adminUserId: z
            .number()
            .int()
            .positive('Admin User ID must be a positive integer')
            .max(Number.MAX_SAFE_INTEGER, 'Admin User ID too large'),
        oneTimePassword: z.string().min(1, 'One-time password is required'),
        referrer: z.string().optional(),
        app: z.string().optional(),
    })
    .strict();

/**
 * Type for impersonate user request payload.
 */
export type ImpersonateUserRequest = z.infer<typeof ImpersonateUserRequestSchema>;

/**
 * Type predicate function to check if a value is a valid ImpersonateUserRequest.
 *
 * @param value - The value to check
 * @returns True if the value is a valid ImpersonateUserRequest
 */
export function isImpersonateUserRequest(value: unknown): value is ImpersonateUserRequest {
    return ImpersonateUserRequestSchema.safeParse(value).success;
}
